<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("centerperson") }}</h4>
        </div>
      </div>
    </div>


    <!--content start-->
    <div id="person">
      <div class="grab">
        <table style="width:100%">
          <tr>
            <th> {{ $t("major") }}</th>
            <th> {{ $t("name") }}</th>
            <th> {{ $t("position") }}</th>
            <th> {{ $t("email") }} / {{ $t("web") }}</th>
          </tr>
          <tr>
            <td> {{ $t("person_part_1") }}</td>
            <td> {{ $t("JeeJunbeom") }}</td>
            <td> {{ $t("director_of_center") }} / {{ $t("research_professor") }}</td>
            <td> rokmcjjb717@hufs.ac.kr <br>
              <a onclick="window.open('https://www.researchgate.net/profile/Joon_Bum_Jee')">https://www.researchgate.net/profile/Joon_Bum_Jee</a>
            </td>
          </tr>
          <tr>
            <td> {{ $t("person_part_2") }}</td>
            <td> {{ $t("ChangMin") }}</td>
            <td> {{ $t("team_leader") }} / {{ $t("research_professor") }}</td>
            <td> mjang@hufs.ac.kr </td>
          </tr>
<!--          <tr>-->
<!--            <td> {{ $t("CheJeonghun") }}</td>-->
<!--            <td> {{ $t("head_researcher") }}</td>-->
<!--            <td> jhchae@hufs.ac.kr </td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td> {{ $t("MinJaesik") }}</td>-->
<!--            <td> {{ $t("head_researcher") }}</td>-->
<!--            <td> min_jaesik@hufs.ac.kr</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td> {{ $t("KangMinsu") }}</td>-->
<!--            <td> {{ $t("senior_researcher") }}</td>-->
<!--            <td> kangms8993@gmail.com</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td> {{ $t("KimEunhye") }}</td>-->
<!--            <td> {{ $t("research_assistant") }}</td>-->
<!--            <td> eunhyehihi@naver.com </td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td> {{ $t("person_part_3") }}</td>-->
<!--            <td> {{ $t("JeeJunbeom") }}</td>-->
<!--            <td> {{ $t("team_leader") }} / {{ $t("research_professor") }}</td>-->
<!--            <td> rokmcjjb717@hufs.ac.kr <br>-->
<!--              <a onclick="window.open('https://www.researchgate.net/profile/Joon_Bum_Jee')">https://www.researchgate.net/profile/Joon_Bum_Jee</a>-->
<!--            </td>-->
<!--          </tr>-->
          <tr>
            <td rowspan="10"> {{ $t("person_part_4") }}</td>
            <td> {{ $t("LeeChaeyeon") }}</td>
            <td> {{ $t("team_leader") }} / {{ $t("research_professor") }}</td>
            <td> prpr2222@hufs.ac.kr <br>
              <a onclick="window.open('https://www.researchgate.net/profile/Chaeyeon_Yi')">https://www.researchgate.net/profile/Chaeyeon_Yi</a>
            </td>
          </tr>
          <tr>
            <td> {{ $t("AnnSukhui") }}</td>
            <td> {{ $t("head_researcher") }}</td>
            <td> shahn@hufs.ac.kr </td>
          </tr>
          <tr>
            <td> {{ $t("YangHojin") }}</td>
            <td> {{ $t("senior_researcher") }}</td>
            <td> hobakzzz@nate.com </td>
          </tr>
          <tr>
            <td> {{ $t("KwonHyeokgi") }}</td>
            <td> {{ $t("senior_researcher") }}</td>
            <td> hghg8743@gmail.com </td>
          </tr>
          <tr>
            <td>이한경</td>
            <td> {{ $t("senior_researcher") }}</td>
            <td> hklee@hufs.ac.kr </td>
          </tr>
          <tr>
            <td> {{ $t("KimYongjun") }}</td>
            <td> {{ $t("research_professor") }}</td>
            <td> vision4g@gmail.com </td>
          </tr>
          <!--
          <tr>
            <td> {{ $t("ChoeMinyeong") }}</td>
            <td> {{ $t("research_assistant") }}</td>
            <td> mychoi1119@naver.com </td>
          </tr>
          -->
          <tr>
            <td> {{ $t("LeeGiyeol") }}</td>
            <td> {{ $t("research_assistant") }}</td>
            <td> lgy5848@naver.com </td>
          </tr>
          <tr>
            <td>김태석</td>
            <td>연구보조원</td>
            <td>ktskts33@naver.com</td>
          </tr>
          <tr>
            <td>배효정</td>
            <td>연구보조원</td>
            <td>baehyojeong@naver.com</td>
          </tr>
          <tr>
            <td>이의진</td>
            <td>연구보조원</td>
            <td>ej5762@naver.com</td>
          </tr>
          <tr>
            <td rowspan="3"> {{ $t("person_part_5") }}</td>
            <td> {{ $t("JoeChangrae") }}</td>
            <td> {{ $t("team_leader") }} / {{ $t("research_professor") }}</td>
            <td> crcho@hufs.ac.kr</td>
          </tr>
          <tr>
            <td> {{ $t("LeeSanghui") }}</td>
            <td> {{ $t("research_professor") }}</td>
            <td> sangheelee.atmos@gmail.com</td>
          </tr>
          <tr>
            <td> {{ $t("LeeJunseok") }}</td>
            <td> {{ $t("research_professor") }}</td>
            <td> jlee@hufs.ac.kr</td>
          </tr>
          <tr>
            <td> {{ $t("person_part_3") }}</td>
            <td> </td>
            <td> </td>
            <td> </td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'CenterPerson'
  }
</script>
<style scoped>
  table tr {
    height: 48px;
    text-align: center;
    font-size: 16px
  }
  table tr th {
    background-color: #f2f2f2;
    text-align: center;
    border-bottom: 1px solid #d7d7d7;
    border-top: 1px solid #d7d7d7;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CenterPerson.vue